= <template>
    <div class="MapForm">
        <div class="flex row-left-center mb-2">
            <div class="flex-1">
                <WText
                    tag="label"
                    typo="label"
                    :size="14"
                >
                    {{ $t('entities.dicts.map.alias.label') }}
                </WText>
                <WFieldError
                    :validator="$v.alias"
                    :label="$t('entities.dicts.map.alias.label')"
                    #default="{ errorMessage, listeners }"
                >
                    <WInput
                        v-model="alias"
                        :error="errorMessage"
                        :placeholder="$t('entities.dicts.map.alias.placeholder')"
                        :disabled="isLoading"
                        name="alias"
                        type="text"
                        v-on="listeners"
                    />
                </WFieldError>
            </div>

            <div class="flex-1 ml-1">
                <WText
                    tag="label"
                    typo="label"
                    :size="14"
                >
                    {{ $t('entities.dicts.map.value.label') }}
                </WText>
                <WFieldError
                    :validator="$v.value"
                    :label="$t('entities.dicts.map.value.label')"
                    #default="{ errorMessage, listeners }"
                >
                    <WSelect
                        v-model="value"
                        :error="errorMessage"
                        name="value"
                        :placeholder="$t('entities.dicts.map.value.placeholder')"
                        :options="options"
                        :disabled="isLoading"
                        v-on="listeners"
                    />
                </WFieldError>
            </div>
        </div>

        <div class="flex row-right-center">
            <WButton
                outline
                color="accent-blue"
                :loading="isLoading"
                @click="$emit('onReset')"
            >
                {{ $t('entities.creation.reset') }}
            </WButton>
            <WButton
                color="primary"
                :loading="isLoading"
                :disabled="isLoading"
                class="ml-2"
                @click="handleSubmit"
            >
                {{ $t('entities.dicts.create.submit') }}
            </WButton>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { Api, apiRequest } from '@/api'

export default {
    name: 'MapForm',
    mixins: [validationMixin],
    props: {
        dictKey: VueTypes.oneOfType([Number, String]).isRequired,
        fieldType: VueTypes.string.def('maps'),
        options: VueTypes.arrayOf(VueTypes.shape({
            key: VueTypes.oneOfType([Number, String]).isRequired,
            label: VueTypes.oneOfType([Number, String]).isRequired,
        }).loose),
    },
    data () {
        return {
            alias: '',
            value: '',

            isLoading: false,
        }
    },
    validations () {
        return {
            alias: { required },
            value: { required },
        }
    },
    methods: {
        async handleSubmit () {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.isLoading = true
                const params = { dictKey: this.dictKey, fieldType: this.fieldType, params: { alias: this.alias, value: this.value } }
                apiRequest(Api().dictionaries.fieldCreate(params))
                    .then(() => this.$emit('onSubmit', params))
                    .catch(() => this.$emit('onError'))
                    .finally(() => (this.isLoading = false))
            }
        },
    },
}
</script>
